const c = {
  name: "Apps",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M3,0C1.3,0,0,1.3,0,3v12c0,1.7,1.3,3,3,3h12c1.7,0,3-1.3,3-3V3c0-1.7-1.3-3-3-3H3z M2,3c0-0.6,0.4-1,1-1h12
			c0.6,0,1,0.4,1,1v12c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V3z"/>
		<path class="st0" d="M25,0c-1.7,0-3,1.3-3,3v12c0,1.7,1.3,3,3,3h12c1.7,0,3-1.3,3-3V3c0-1.7-1.3-3-3-3H25z M24,3c0-0.6,0.4-1,1-1
			h12c0.6,0,1,0.4,1,1v12c0,0.6-0.4,1-1,1H25c-0.6,0-1-0.4-1-1V3z"/>
		<path class="st0" d="M0,25c0-1.7,1.3-3,3-3h12c1.7,0,3,1.3,3,3v12c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V25z M3,24c-0.6,0-1,0.4-1,1
			v12c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1V25c0-0.6-0.4-1-1-1H3z"/>
		<path class="st0" d="M25,22c-1.7,0-3,1.3-3,3v12c0,1.7,1.3,3,3,3h12c1.7,0,3-1.3,3-3V25c0-1.7-1.3-3-3-3H25z M24,25
			c0-0.6,0.4-1,1-1h12c0.6,0,1,0.4,1,1v12c0,0.6-0.4,1-1,1H25c-0.6,0-1-0.4-1-1V25z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Apps
};
